import React, { useState } from "react";
import {
    Dialog,
    DialogContent,
    TextField,
    Typography,
    Slider,
    Button,
    IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const StitchCalculatorModal = ({ open, onClose }) => {
    const [back, setBack] = useState("");
    const [hand, setHand] = useState("");
    const [rpm, setRpm] = useState(350);

    const calculateTime = () => {
        const total =
            (parseInt(back) || 0) +
            (parseInt(hand) || 0) * 2;

        if (!total) return "0 Minutes";

        const minutes = total / rpm;

        if (minutes >= 60) {
            const h = Math.floor(minutes / 60);
            const m = Math.round(minutes % 60);
            return `${h} H ${m} M`;
        }

        if (minutes >= 1) {
            return `${Math.round(minutes)} Minute${Math.round(minutes) > 1 ? "s" : ""
                }`;
        }

        const sec = Math.round(minutes * 60);

        return `${sec} Second${sec > 1 ? "s" : ""}`;
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: {
                    borderRadius: 24,
                    overflow: "hidden",
                    background: "#ffffff",
                    boxShadow:
                        "0 30px 80px rgba(0,0,0,.18)",
                },
            }}
        >
            {/* Header */}

            <div
                style={{
                    backgroundColor: "#001f3f",
                    padding: "28px 32px",
                    position: "relative",
                }}
            >
                <IconButton
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        right: 18,
                        top: 18,
                        background: "rgba(255,255,255,.18)",
                        color: "#fff",
                        backdropFilter: "blur(10px)",
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Typography
                    style={{
                        color: "#fff",
                        fontSize: 26,
                        fontWeight: 700,
                        letterSpacing: ".4px",
                    }}
                >
                    🧵 Stitch Calculator
                </Typography>

                <Typography
                    style={{
                        color: "rgba(255,255,255,.88)",
                        marginTop: 6,
                        fontSize: 14,
                    }}
                >
                    Calculate embroidery stitching time instantly.
                </Typography>
            </div>

            <DialogContent
                style={{
                    padding: 32,
                    background: "#F8FAFC",
                }}
            >
                {/* Back Stitch */}

                <TextField
                    fullWidth
                    variant="outlined"
                    label="Back Stitches"
                    type="number"
                    value={back}
                    onChange={(e) => setBack(e.target.value)}
                    style={{ marginBottom: 22 }}
                    InputProps={{
                        style: {
                            borderRadius: 16,
                            background: "#fff",
                            height: 56,
                        },
                    }}
                />

                {/* Hand Stitch */}

                <TextField
                    fullWidth
                    variant="outlined"
                    label="Hand Stitches"
                    type="number"
                    value={hand}
                    onChange={(e) => setHand(e.target.value)}
                    InputProps={{
                        style: {
                            borderRadius: 16,
                            background: "#fff",
                            height: 56,
                        },
                    }}
                />

                {/* RPM Section */}

                <div
                    style={{
                        marginTop: 35,
                        padding: 22,
                        background: "#fff",
                        borderRadius: 18,
                        boxShadow:
                            "0 10px 30px rgba(0,0,0,.05)",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 12,
                        }}
                    >
                        <Typography
                            style={{
                                fontWeight: 600,
                                color: "#374151",
                            }}
                        >
                            Machine Speed
                        </Typography>

                        <div
                            style={{
                                background: "linear-gradient(to right, rgba(230, 92, 91, 0.9), rgba(245, 93, 44, 0.9))",
                                color: "#fff",
                                padding: "6px 16px",
                                borderRadius: 30,
                                fontWeight: 700,
                                fontSize: 14,
                            }}
                        >
                            {rpm} RPM
                        </div>
                    </div>

                    <Slider
                        value={rpm}
                        min={350}
                        max={1000}
                        step={50}
                        onChange={(e, value) => setRpm(value)}
                        valueLabelDisplay="auto"
                    />
                </div>

                {/* Estimated Time */}

                <div
                    style={{
                        marginTop: 28,
                        padding: 28,
                        textAlign: "center",
                        borderRadius: 22,
                        background:
                            "linear-gradient(135deg,#EFF6FF,#DBEAFE)",
                        border: "1px solid #BFDBFE",
                    }}
                >
                    <Typography
                        style={{
                            color: "#FD7E14",
                            fontSize: 15,
                            fontWeight: 600,
                            letterSpacing: 1,
                        }}
                    >
                        ESTIMATED TIME
                    </Typography>

                    <Typography
                        style={{
                            marginTop: 12,
                            fontSize: 34,
                            fontWeight: 700,
                            color: "#111827",
                        }}
                    >
                        {calculateTime()}
                    </Typography>
                </div>

                {/* Close Button */}

                <Button
                    fullWidth
                    variant="contained"
                    onClick={onClose}
                    style={{
                        marginTop: 30,
                        height: 54,
                        borderRadius: 14,
                        fontSize: 16,
                        fontWeight: 700,
                        textTransform: "none",
                        background: "linear-gradient(to right, rgba(230, 92, 91, 0.9), rgba(245, 93, 44, 0.9))",
                        color: "#fff",
                        boxShadow: "0 12px 30px rgba(245, 93, 44, 0.35)",
                    }}
                >
                    Close
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default StitchCalculatorModal;